module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\"><path d=\"M13.02 1.293l1.414 1.414a1 1 0 0 1 0 1.414L4.119 14.436a1 1 0 0 1-.704.293l-2.407.008L1 12.316a1 1 0 0 1 .293-.71L11.605 1.292a1 1 0 0 1 1.414 0zm-1.416 1.415l-.707.707L12.31 4.83l.707-.707-1.414-1.415zM3.411 13.73l1.123-1.122H3.12v-1.415L2 12.312l.005 1.422 1.406-.005z\"/></svg>\n\n"


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/app/views/shared/icons/_icon_pencil.svg
// module id = ../../views/shared/icons/_icon_pencil.svg
// module chunks = pages.projects.issues.show pages.projects.merge_requests.show